import { Injectable } from '@angular/core';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';

@Injectable()
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (params.key.startsWith('APPR_REGISTRY_')) {
      return params.key.replace('APPR_REGISTRY_', '');
    } else if (params.key.startsWith('APPR_TYPE_ASSETS_')) {
      return params.translateService.instant(params.key.replace('APPR_TYPE_ASSETS_', ''));
    } else if (params.key.startsWith('error_')) {
      return params.translateService.instant('error_GENERIC');
    } else {
      return params.key;
    }
  }
}
